<div id="content" class="main-content">
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <blockquote class="blockquote">
                <h2>Journal d'audit <span class="flaticon-reload-dash refreshIcone" (click)="getAllContacts()"></span></h2>
                    <div class="d-flex justify-content-between">
                        <div class="d-flex">
                            <div class="f-head mr-3">
                                <img src="../../../assets/img/suivitim_img/audit_journal.gif" alt="" style="width:70px"> 
                            </div>
                            <div class="f-body">
                                <b style="font-size: large;color: #334c86;">Pour une meilleure visibilité</b>
                                <p style="color:#788fa6;">Cette page présente l'ensemble des actions critiques 
                                    effectuées par les utilisateurs du système : créations, mises à jour, affectations, 
                                    clôtures, etc. <br>Chaque opération est enregistrée pour garantir la traçabilité et la transparence.</p>
                            </div>
                        </div>
                    </div>
            </blockquote>
        </div>
    </div>
    <div class="row">
        <div class="col col-lg-12">
            <blockquote class="blockquote">
                <div class="row" id="cancel-row" >
                    <div class="col-xl-12 col-lg-12 pr-0 pl-0 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">       
                                </div>
                            </div>
                            <div class="widget-content widget-content-area pl-0 pr-1">
                                <div *ngIf="auditLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                margin-bottom: 15%;"></div>
                                <div class="table-responsive mb-4" *ngIf="!auditLoading">
                                    <table id="audit_table" class="table table-striped table-bordered table-hover display w-100">
                                        <thead>
                                            <tr>
                                                <th>Date et heure</th>
                                                <th>Faite par</th>
                                                <th>Utilisateur</th>
                                                <th>Module</th>
                                                <th class="operation_header">Opération</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let trace of allAudits">
                                                <td>
                                                    {{ trace.actionDate | date: 'dd/MM/yyyy- HH:mm' }}
                                                </td>
                                                <td>
                                                    {{ trace.user || '- - -'}}
                                                </td>
                                                <td>
                                                    {{ trace.userConcerned || '- - -'}}
                                                </td>
                                                <td>
                                                    <span class="badge badge-success" *ngIf="trace.module=='Profiles'">{{ trace.module || '- - -'}}</span>
                                                    <span *ngIf="trace.module!='Profiles'">{{ trace.module || '- - -'}}</span>
                                                </td>
                                                <td style="width: 460px !important">
                                                    {{ trace.action || '- - -'}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
            </blockquote>
        </div>
    </div> 
</div>
